<template>
  <div class="mb-3 rounded-md bg-off-white p-3">
    <p class="text-left text-gray-over-dark">
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotFMSCABox',
};
</script>
